import React from 'react';
import { Box, Link, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const FOOTER_LAYOUT_PREFIXES = ['/app', '/help', '/datenschutz', '/impressum', '/kontakt', '/barrierefreiheit'];

function pathHasFooter(pathname: string): boolean {
  return FOOTER_LAYOUT_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/** Reopens the banner on routes without Footer (e.g. login, landing). */
const CookieSettingsShortcut: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const { choice, bannerOpen, openCookieSettings } = useCookieConsent();

  if (choice === null || bannerOpen || pathHasFooter(location.pathname)) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        zIndex: theme.zIndex.snackbar - 1,
      }}
    >
      <Link
        component="button"
        type="button"
        onClick={openCookieSettings}
        sx={{
          cursor: 'pointer',
          border: 0,
          background: 'rgba(255,255,255,0.92)',
          boxShadow: 1,
          borderRadius: 1,
          px: 1.5,
          py: 0.75,
          font: 'inherit',
          color: 'primary.main',
          textDecoration: 'underline',
        }}
      >
        Cookie-Einstellungen
      </Link>
    </Box>
  );
};

export default CookieSettingsShortcut;
